import { Player } from '@lottiefiles/react-lottie-player'
import arrowRightAnimationData from './arrows-right.lottie.json'

const ArrowAnimation = () => {
  return (
    <div className='relative' style={{ width: 30, height: 30 }}>
      <Player autoplay loop src={arrowRightAnimationData} style={{ width: 30, height: 30 }} />
    </div>
  )
}

export default ArrowAnimation
